"use client";

import { QRCode } from "react-qrcode-logo";

/**
 * Custom QR Code component with Qensa branding
 * @param {Object} props
 * @param {string} props.value - The value to encode in the QR code
 * @param {number} props.size - Size of the QR code (default: 200)
 * @param {string} props.bgColor - Background color (default: white)
 * @param {string} props.fgColor - Foreground color (default: Qensa primary)
 * @param {boolean} props.includeLogo - Whether to include Qensa logo (default: true)
 * @param {string} props.logoImage - Custom logo image URL (default: Qensa logo)
 * @param {number} props.logoWidth - Logo width (default: 60)
 * @param {number} props.logoHeight - Logo height (default: 60)
 * @param {boolean} props.logoOpacity - Logo opacity (default: 1)
 * @param {boolean} props.removeQrCodeBehindLogo - Remove QR code behind logo (default: true)
 * @param {string} props.errorCorrectionLevel - Error correction level (default: H)
 * @param {...any} otherProps - Additional props to pass to QRCode component
 */
const QensaQRCode = ({
  value,
  size = 200,
  bgColor = "#FFFFFF",
  fgColor = "#000000", // Qensa primary color
  includeLogo = true,
  logoImage = "/logos/q/purple.png", // Default to Qensa purple logo
  logoWidth = 60,
  logoHeight = 60,
  logoOpacity = 1,
  removeQrCodeBehindLogo = true,
  errorCorrectionLevel = "H",
  ...otherProps
}) => {
  return (
    <QRCode
      value={value}
      size={size}
      bgColor={bgColor}
      fgColor={fgColor}
      logoImage={includeLogo ? logoImage : undefined}
      logoWidth={includeLogo ? logoWidth : undefined}
      logoHeight={includeLogo ? logoHeight : undefined}
      logoOpacity={includeLogo ? logoOpacity : undefined}
      removeQrCodeBehindLogo={includeLogo ? removeQrCodeBehindLogo : undefined}
      ecLevel={errorCorrectionLevel}
      enableCORS={true}
      qrStyle="squares" // Clean square style
      eyeRadius={[
        [10, 10, 0, 10], // top/left eye
        [10, 10, 10, 0], // top/right eye
        [10, 0, 10, 10], // bottom/left eye
      ]}
      {...otherProps}
    />
  );
};

export default QensaQRCode;
